import { gql } from '@apollo/client';

export const fetchAvailableOfferingsForChangeSubscription = gql`
  query fetchAvailableOfferingsForChangeSubscription($id: String) {
    entitlementDetails(id: $id) {
      id
      availableOfferings {
        id
        name
        level
        key
        sku
        productKey
        pricingType
        status
        derivedFromOffering {
          templateId
          templateVersion
          originalOfferingKey
        }
        availableAddOns {
          offeringId
          name
        }
      }
    }
  }
`;
